import React, { Component } from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import {getDayOfWeekPT} from '../Common/helpers';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

class PrintStaffSchedule extends Component {
    constructor(props) {
        super(props);

        this.state = {
            staffId: props.props.match.params.id
            ,fetchStores:null
            ,fetchData:null
            ,year:props.props.match.params.year
            ,month:props.props.match.params.month
            ,hoursIn: {}
            ,hoursOut: {}
            ,stores: {}
        };

    }

    filledInfields = false;

    componentWillMount() {
        const getTotals = this.props.loginData.AccessLevel ? "&gettotals=1" : "";

        Promise.all([
            fetch(API + "getschedules&getbystaffid=" + this.state.staffId + "&year=" + this.state.year + "&month=" + this.state.month + getTotals)
            ,fetch(API + "getstores")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            this.filledInfields = false;
            this.setStateObjs(data[0], this.state.year, this.state.month);
            this.setState({ fetchData: data[0], fetchStores: data[1].data, isActive:1 });
        });
        document.body.classList.add('print-page');

        setTimeout(function(){
            window.print();
        }, 300);
    }

    fetchData = () => {
        const getTotals = this.props.loginData.AccessLevel ? "&gettotals=1" : "";
        fetch(API + 'getschedules&getbystaffid=' + this.state.staffId + "&year=" + this.state.year + "&month=" + this.state.month + getTotals)
        .then(response => response.json())
        .then(result => {
            if(result === null || result.shortmsg === "NOK"){
                this.props.props.history.push('/Staff/Schedules');
                return;
            }
            this.setState({ fetchData: result })
        });
    }

    setStateObjs = (fetchData, year, month) => {
        if(!this.filledInfields&&fetchData!==null){
            this.filledInfields = true;
            var data = fetchData.data.days
                , hoursInObj = {}
                , hoursOutObj = {}
                , storesObj = {};

            for(var i=0,n=data.length;i<n;i++){
                hoursInObj["hoursIn_"+data[i].Date] = moment(data[i].Date + " " + data[i].HoursIn);
                hoursOutObj["hoursOut_"+data[i].Date] = moment(data[i].Date + " " + data[i].HoursOut);
                storesObj["stores_"+data[i].Date] = data[i].StoreId;
            }

            this.setState({fetchData: fetchData, year: year, month: month, hoursIn: hoursInObj, hoursOut: hoursOutObj, stores: storesObj });
        }
    }

    renderStoresOptions = (e) => {
        const stores = this.state.fetchStores;
        if(stores===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            items.push(<MenuItem value={stores[i].Id} key={stores[i].Id}>
                             {<div><div className="smallColorDiv" style={{backgroundColor: stores[i].Color}}></div> <span>{stores[i].Name + " - " + stores[i].Shortname}</span></div>}
                       </MenuItem>);
        }
        return items;
    }

    renderStore = (storeId) => {    
        if(!this.state.fetchStores){
            return <div>---</div>;
        }

        const store = this.state.fetchStores.filter(x => x.Id === storeId)[0];

        return (
            <div>
                <div className="smallColorDiv" style={{backgroundColor: store.Color}}></div> <span>{store.Name + " - " +store.Shortname}</span>
            </div>);
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { fetchData } = this.state;
        const schedules = fetchData ? fetchData.data.days : []
              , staffName = fetchData ? fetchData.data.staff[0].FirstName + " " + fetchData.data.staff[0].LastName : [];

        return (
                <div id="printStaffSchedulePage" className="printContent">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="pageHeader">
                                <h1>                                    
                                    <p className="dateHolder"><i className="fa fa-user-md"></i> {staffName} - <span className="selectedDate"><span className="capitalize">{moment(this.state.month).format("MMMM")}</span> de {this.state.year}</span></p>
                                </h1>
                            </div>
                            <Table className="customTable">
                                <TableHead>
                                    <TableRow className="printTableRow tableHeader">
                                        <TableCell className="tableCell first">Dia</TableCell>
                                        <TableCell className="tableCell second">Dia da Semana</TableCell>
                                        <TableCell className="tableCell third">Entrada</TableCell>
                                        <TableCell className="tableCell fourth">Saída</TableCell>
                                        <TableCell className="tableCell fifth">Clinica</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody ref="tableBody">
                                    {schedules.map(schedule => {
                                        let isDayOff = schedule.DayOff==="1" ? "disabledRow" : ""
                                            ,validJust = schedule.IsValidJustification==="0" ? "invalidJustification" : "";

                                        return(
                                            <TableRow key={schedule.Day} className={"printTableRow " + isDayOff + " " + validJust}>
                                                <TableCell className="tableCell first">{schedule.Day}</TableCell>
                                                <TableCell className="tableCell second">{getDayOfWeekPT(schedule.DayOfWeek)}</TableCell>
                                                <TableCell className="tableCell third">   
                                                    <p className="value"> {isDayOff ? "---" : moment(this.state.hoursIn["hoursIn_"+schedule.Date]).format('HH:mm')}</p>
                                                </TableCell>
                                                <TableCell className="tableCell fourth">
                                                    <p className="value"> {isDayOff ? "---" : moment(this.state.hoursOut["hoursOut_"+schedule.Date]).format('HH:mm')}</p>
                                                </TableCell>
                                                <TableCell className="tableCell fifth">
                                                    {isDayOff ? "---" : this.renderStore(this.state.stores["stores_"+schedule.Date])}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                    {(isAdmin || loginData.profile.Schedules.seeTotals) && fetchData &&
                                        <TableRow key="totals" className={"printTableRow"}>
                                            <TableCell className="tableCell first" colSpan="2"><p className="totals">Totais:</p></TableCell>
                                            <TableCell className="tableCell second">
                                                <p className="smallText">Total de Dias:</p>
                                                <p id="totalDays" className="value">{fetchData.data.totals[0].TotalDays}</p>
                                            </TableCell>
                                            <TableCell className="tableCell third">   
                                                <p className="smallText">Total de Horas:</p>
                                                <p id="totalHours" className="value">{fetchData.data.totals[0].TotalHoursMinusPauses}</p>
                                            </TableCell>
                                            <TableCell className="tableCell fourth">
                                                <p className="smallText">Total de Pausas:</p>
                                                <p id="totalPauses" className="value">{fetchData.data.totals[0].TotalPauses}</p>
                                            </TableCell>
                                        </TableRow>
                                    }

                                </TableBody>
                            </Table>
                        </div>
    				</div>
                </div>
        );
    }
}

export default PrintStaffSchedule;
